export default "__VITE_ASSET__A3TCH0UJ__"